import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { Credentials, CredentialsID } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { retrieveCredentialsKeys } from './constants';

export const useRetrieveCredentials = (
  id: CredentialsID | undefined,
  options?: IUseQueryOptionsExtended<Credentials | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => retrieveCredentialsKeys.concat(id), [id]);

  return useEitherQuery(
    keys,
    () => {
      return services2.adminCredentialsManagementService.retrieve(id as CredentialsID);
    },
    {
      placeholderData: keepPreviousData,
      ...options,
      enabled: (options?.enabled ?? true) && id !== undefined,
    }
  );
};
